<template>
    <div class="categories">
        <div class="row">
            <div class="col-lg-4 col-md-6"
                v-for="subcategory in subcategories"
                :key="subcategory.id">
                <a :href="subcategory.detail_url" class="box">
                    <div class="image-wrap">
                        <img :src="subcategory.image" alt="">
                    </div>
                    <div class="text">
                        <h4>{{ subcategory.name }}</h4>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({

    props: ['subcategories'],
})
</script>
